export const SET_LOCALE = 'SET_LOCALE';
export const GET_LOCALE = 'GET_LOCALE';
export const LOAD_MESSAGES = 'LOAD_MESSAGES';

export const FETCH_TRANSLATIONS_REQUEST = 'FETCH_TRANSLATIONS_REQUEST';
export const FETCH_TRANSLATIONS_SUCCESS = 'FETCH_TRANSLATIONS_SUCCESS';
export const FETCH_TRANSLATIONS_FAILURE = 'FETCH_TRANSLATIONS_FAILURE';

export const FETCH_SUPPORTED_LANGUAGES_REQUEST = 'FETCH_SUPPORTED_LANGUAGES_REQUEST';
export const FETCH_SUPPORTED_LANGUAGES_SUCCESS = 'FETCH_SUPPORTED_LANGUAGES_SUCCESS';
export const FETCH_SUPPORTED_LANGUAGES_FAILURE = 'FETCH_SUPPORTED_LANGUAGES_FAILURE';

export const CLEAR_TRANSLATIONS = 'CLEAR_TRANSLATIONS';
